var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQrCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.833,
    height: 41.833,
    viewBox: "0 0 41.833 41.833",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "qr-code_svg__Path_697",
    "data-name": "Path 697",
    d: "M30.889,44.833H26.241V40.185h4.648ZM26.241,28.565H21.593v11.62h4.648Zm18.593-4.648H40.185v9.3h4.648Zm-4.648-4.648H35.537v4.648h4.648ZM12.3,23.917H7.648v4.648H12.3ZM7.648,19.269H3v4.648H7.648ZM23.917,7.648h4.648V3H23.917ZM6.486,6.486v6.972h6.972V6.486ZM16.944,16.944H3V3H16.944ZM6.486,34.375v6.972h6.972V34.375ZM16.944,44.833H3V30.889H16.944ZM34.375,6.486v6.972h6.972V6.486ZM44.833,16.944H30.889V3H44.833ZM40.185,40.185V33.213h-9.3v4.648h4.648v6.972h9.3V40.185ZM35.537,23.917h-9.3v4.648h9.3Zm-9.3-4.648H12.3v4.648h4.648v4.648h4.648V23.917h4.648Zm2.324-2.324V12.3H23.917V7.648H19.269v9.3ZM11.715,8.229H8.229v3.486h3.486Zm0,27.889H8.229V39.6h3.486ZM39.6,8.229H36.118v3.486H39.6Z",
    transform: "translate(-3 -3)",
    fill: "#494f5d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.083353c2ef6605de0f5c90ee1d0374ab.svg";
export { ForwardRef as ReactComponent };